/**
 * Sysadmin Runtime — parent layout (Wave 3 §10.2 #5 / spec §3.5).
 */

import { createFileRoute, Link, Outlet, useLocation } from '@tanstack/react-router';
import { Heart, HardDrive, Layers, Cpu, Network, Database } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

export const Route = createFileRoute('/sysadmin/runtime')({
  component: RuntimeLayout,
});

const SUB_TABS = [
  { key: 'health',    label: 'Health',         icon: Heart,    to: '/sysadmin/runtime/health',    status: 'v1' },
  { key: 'hardware',  label: 'Hardware',       icon: HardDrive, to: '/sysadmin/runtime/hardware',  status: 'v1' },
  { key: 'queues',    label: 'Queues',         icon: Layers,   to: '/sysadmin/runtime/queues',    status: 'v1' },
  { key: 'inference', label: 'Inference',      icon: Cpu,      to: '/sysadmin/runtime/inference', status: 'v1' },
  { key: 'mcp',       label: 'MCP Sandboxes',  icon: Network,  to: '/sysadmin/runtime/mcp',       status: 'v1' },
  { key: 'storage',   label: 'Storage',        icon: Database, to: '/sysadmin/runtime/storage',   status: 'v1' },
] as const;

function RuntimeLayout() {
  const location = useLocation();

  return (
    <div className="flex flex-col h-full">
      <div className="border-b sticky top-0 bg-background z-10">
        <nav className="flex items-center gap-0.5 overflow-x-auto px-6">
          {SUB_TABS.map((t) => {
            const Icon = t.icon;
            const active = location.pathname === t.to ||
              location.pathname.startsWith(t.to + '/');
            return (
              <Link
                key={t.key}
                to={t.to}
                className={cn(
                  'flex items-center gap-2 px-3 py-2 text-sm font-medium border-b-2 transition-colors whitespace-nowrap',
                  active
                    ? 'border-primary text-foreground'
                    : 'border-transparent text-muted-foreground hover:text-foreground',
                )}
              >
                <Icon className="h-4 w-4" />
                {t.label}
                {t.status !== 'v1' && (
                  <Badge variant="secondary" className="ml-1 text-[10px]">
                    {t.status}
                  </Badge>
                )}
              </Link>
            );
          })}
        </nav>
      </div>

      <div className="flex-1 overflow-y-auto">
        <Outlet />
      </div>
    </div>
  );
}
